import { render, staticRenderFns } from "./ButtonCustom.vue?vue&type=template&id=731b68e2"
import script from "./ButtonCustom.vue?vue&type=script&lang=js"
export * from "./ButtonCustom.vue?vue&type=script&lang=js"
import style0 from "./ButtonCustom.vue?vue&type=style&index=0&id=731b68e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports